import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  stats : {
    balance : null,
    credit : null
  },
  invoices : [],
  customerId : null,
  loading : true,
  outDated : true,
  nextPaymentDate : null,
  amountDue : null,
  selectedInvoices : [],
  loadingStats : true,
  portausCompanyId: null,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
